<BolideLoader v-show="is_loading" />
<div class="dashboard-container container-fluid px-0" v-show="!is_loading">
    <div class="row g-0 vh-100 overflow-hidden">
        <!-- ======= SIDEBAR AREA (DESKTOP ONLY) ======= -->
        <div
            v-if="!is_mobile"
            class="col-auto sidebar-wrapper sidebar-offset
                    d-flex flex-column flex-shrink-0
                    position-sticky
                    vh-100
                    overflow-hidden
                    overflow-x-visible"
            :class="{ 'sidebar-collapsed': sidebar_collapsed }">

            <PortfolioSidebar 
                v-if="!is_property_view"
                :tiles="tiles"
                :current_active_property="selected_property?.title"
                @tile-clicked="handleTileClick"
                @global-menu-selected="handleGlobalMenuSelected"
                @property-menu-selected="handlePropertyMenuSelected"
                @global-selected="goBack"
            />

            <PropertySidebar
                v-else-if="selected_property"
                :active_property="selected_property"
                :properties="tiles"
                @switch-property="handleTileClick"
                @go-back="goBack"
                @property-menu-selected="handlePropertyMenuSelected"
            />

        </div>
        <!-- ======= MOBILE SIDEBAR OVERLAY ======= -->
        <div
            v-if="is_mobile && mobile_sidebar_open"
            class="mobile-sidebar-overlay"
            @click.self="close_sidebar"
            >
            <div class="mobile-sidebar-panel">

                <!-- ===== PORTFOLIO MODE ===== -->
                <PortfolioSidebar
                v-if="!is_property_view"
                :tiles="tiles"
                :current_active_property="selected_property?.title"
                @tile-clicked="handleTileClick"
                @global-menu-selected="handleGlobalMenuSelected"
                @property-menu-selected="handlePropertyMenuSelected"
                @global-selected="goBack"
                @close-sidebar="close_sidebar"
                >
                <!-- ❌ CLOSE BUTTON -->
                <template #sidebar-header-actions>
                    <button
                    class="sidebar-close-btn"
                    @click="close_sidebar"
                    aria-label="Close sidebar"
                    >
                    <i class="bi bi-x-lg"></i>
                    </button>
                </template>
                </PortfolioSidebar>

                <!-- ===== PROPERTY MODE ===== -->
                <PropertySidebar
                v-else-if="selected_property"
                :active_property="selected_property"
                :properties="tiles"
                @switch-property="handleTileClick"
                @go-back="goBack"
                @property-menu-selected="handlePropertyMenuSelected"
                @close-sidebar="close_sidebar"
                >
                <!-- ❌ CLOSE BUTTON -->
                <template #sidebar-header-actions>
                    <button
                    class="sidebar-close-btn"
                    @click="close_sidebar"
                    aria-label="Close sidebar"
                    >
                    <i class="bi bi-x-lg"></i>
                    </button>
                </template>
                </PropertySidebar>

            </div>
        </div>
        <button
            v-if="!is_mobile"
            class="sidebar-collapse-btn btn btn-sm btn-dark float-start"
            @click="toggleSidebar"
            >
            <i :class="sidebar_collapsed ? 'bi bi-chevron-double-right' : 'bi bi-chevron-double-left'"></i>
        </button>



        <!-- ======= MAIN CONTENT AREA ======= -->
        <div class="col vh-100 overflow-hidden">
            <!-- HEADER -->
            <HeaderSection
                :breadcrumb="breadcrumb"
                :show_parent_breadcrumb="false"
                @breadcrumb-click="handleBreadcrumbClick"
                @open-assistant="showAssistant = true"
                @toggle-mobile-sidebar="toggle_mobile_sidebar"
                />

            <!-- ⭐ Management Contact RIGHT BELOW HEADER ⭐ -->
            <div
                class="d-flex me-2 management-color px-4"
                v-if="management_contact"
                >
                <p class="text-xs me-2 text-white-50">
                    {{ management_contact.role }} :
                </p>
                <p class="text-xs me-2 fw-semibold">
                    {{ management_contact.full_name }}
                </p>

                <p class="text-xs me-2">
                    {{ management_contact.phone }}
                </p>

                <p class="text-xs me-2">
                    {{ management_contact.email }}
                </p>
            </div>


            <BolideAssistant
                :is_open="showAssistant"
                :tiles="tiles"
                :active-property="selected_property"
                @close-assistant="showAssistant = false"
            />

            <main class="dashboard-main">
                <!-- ================= CALCULATOR VIEW ================= -->
                <div v-if="currentView === 'impact-calculator'" class="dashboard-main-view mt-1">
                    <div class="row g-4 px-3 pb-4">
                        <!-- LEFT: INPUTS -->
                        <CalculatorInput @inputs-changed="handleCalculatorInputsChanged" />

                        <!-- RIGHT: OUTCOMES -->
                        <ProjectedOutcomes :outcomes="projected_outcomes" />
                    </div>
                </div>
                <!-- ================= MAIN VIEW (GLOBAL) ================= -->
                <div v-else-if="currentView === 'main'" class="dashboard-main-view mt-1">
                    <div class="row g-0">

                        <PortfolioSuperSetChart :content_class="getMainContentClass()" chart_id="dashboard-main"
                            :iframe_loading="iframeLoading" />
                    </div>
                </div>

                <!-- ============== PROPERTY VIEW ============== -->
                <div v-else-if="is_property_view && !isDetailView(currentView)" class="w-100 h-25">
                    <div class="row">
                        <div class="">
                            <PropertyOverview
                                v-if="selected_property"
                                :centre="selected_property.propertyOverview || {
                                    title: selected_property.title,
                                    size: 'N/A',
                                    occupancy: 'N/A',
                                    description: selected_property.description || 'Property'
                                }"
                                :total_centres="selected_property.propertyOverview?.total_centres || tiles.length"
                            />

                        </div>
                    </div>

                    <!-- LEFT MAIN CONTENT -->
                    <div>

                        <div class="card rounded-3 bg-transparent">

                        <!-- SCROLL AREA -->
                        <div class="p-3 h-100 overflow-auto">

                            <!-- ❗ SHOW SUPERSET ONLY WHEN NOT ON RESOURCES -->
                            <template v-if="active_menu_item !== 'resources'">

                            <!-- Superset Dashboard -->
                            <div class="portfolio-chart mb-4">
                                <div :id="'dashboard-' + currentView"></div>

                                <div v-if="iframeLoading" class="iframe-loading text-center py-3">
                                <div class="spinner-border spinner-border-sm me-2"></div>
                                Loading embedded dashboard...
                                </div>
                            </div>

                            <!-- Emergency Map -->
                            <template v-if="active_menu_item === 'operations-overview'">
                                <!-- Container for spacing -->
                                <div class="d-flex flex-column gap-4">
                                    <template v-for="tileCard in getTileCards()" :key="tileCard.id">
                                        <EmergencyContactMap
                                            v-if="tileCard.type === 'emergency-map'"
                                            :location-name="tileCard.locationName || getCurrentTitle()"
                                            :property-coordinates="selected_property?.coordinates"
                                            :municipality="getPropertyMunicipality()"
                                            :water-utility="getPropertyWaterUtility()"
                                            :tariff-regime="getPropertyTariffRegime()"
                                            :selected-property="selected_property"
                                        />
                                    </template>
                                    
                                    <!-- Updated SecurityDemographicsCompetition with crimeStats prop -->
                                    <SecurityDemographicsCompetition
                                        :crimeStats="currentCrimeStats"
                                        />
                                </div>
                            </template>

                            </template>

                            <!-- ⭐ RESOURCES LAYOUT -->
                            <template v-else>

                            <!-- ROW 1 — DETAILS + RECENT DOCUMENTS -->
                            <div class="row g-4 mb-4">
                                <div class="glass-card rounded-4 col-lg-6">
                                    <div class="card-body">
                                        <p class="text-xs text-white"><i class="bi bi-people-fill text-primary fs-5"></i> On-Site Team Members</p>
                                        <template v-for="tileCard in getTileCards()" :key="'resources-details-' + tileCard.id">
                                            <div v-if="tileCard.type === 'details'">
                                            <DetailsCard
                                                v-for="(contact, index) in tileCard.contacts"
                                                :key="`${tileCard.id}-${index}`"
                                                :accordion_id="`${tileCard.id}-${index}`"
                                                :full_name="contact.full_name"
                                                :role="contact.role"
                                                :status="contact.status"
                                                :hours="contact.hours"
                                                :address="contact.address"
                                                :website="contact.website"
                                                :phone="contact.phone"
                                                :email="contact.email"
                                                />

                                            </div>
                                        </template>
                                    </div>
                                </div>

                                <!-- RECENT DOCUMENTS -->
                                <div class="col-lg-6">
                                <RecentDocuments />
                                </div>

                            </div>

                            <!-- ROW 2 — SHIFT SCHEDULE + QUICK ACTIONS -->
                            <div class="row g-4 mb-4">

                                <!-- SHIFT -->
                                <div class="col-lg-6">
                                <ShiftSchedule
                                    v-if="selected_property"
                                    :shifts="selected_property.shiftSchedule || []"
                                />
                                </div>

                                <!-- QUICK ACTIONS -->
                                <div class="col-lg-6">
                                <QuickActions
                                    v-if="selected_property"
                                    :actions="selected_property.quickActions || []"
                                />
                                </div>

                            </div>

                            </template>

                        </div>

                        </div>

                    </div>

                    <!-- RIGHT SIDEBAR -->
                    <div v-if="hasTileCards() && showRightPanel">
                        <template v-for="tileCard in getTileCards()" :key="tileCard.id">
                        </template>

                    </div>

                </div>

                <!-- ============== DETAIL VIEW ============== -->
                <div v-else-if="isDetailView(currentView)" class="dashboard-detail-view">
                    <div class="card rounded-3 bg-transparent border mt-4 mb-4">
                        <div class="portfolio-chart">
                            <div class="superset-embedded-container m-0 p-0">
                                <div :id="'dashboard-' + currentView"></div>
                                <div v-if="iframeLoading" class="iframe-loading">
                                    <div class="spinner-border spinner-border-sm me-2"></div>
                                    Loading embedded dashboard...
                                    <div v-if="iframeError" class="error-message mt-2 text-danger">
                                        Failed to load dashboard. Please try refreshing.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 🤖 FLOATING VSI ASSISTANT (MOBILE) -->
                <button
                    v-if="is_mobile"
                    class="floating-assistant-btn btn btn-primary d-md-none"
                    @click="showAssistant = true"
                    aria-label="Open assistant"
                    >
                    <i class="bi bi-robot fs-5"></i>
                </button>

            </main>
        </div>

    </div>
</div>
